import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Box, Divider, IconButton, TextButton, Typography } from 'seagull';
import { ChevronDown } from 'seagull/icons/arrows/ChevronDown';
import { ChevronUp } from 'seagull/icons/arrows/ChevronUp';
import { Edit } from 'seagull/icons/content-edit/Edit';
import { PlusCircle } from 'seagull/icons/essentials/PlusCircle';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './MetricsHeaderMobile.module.scss';
export const GetMetricsHeaderMobileTID = (parentTestId)=>getTestIds(parentTestId);
export const MetricsHeaderMobile = (param)=>{
    let { isCollapsed, isEditMode, canCustomize, addWidgetButtonRef, onToggleCollapsed, onCustomizeClick, onAddWidgetClick, onDoneClick, testId } = param;
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const { MetricsHeaderMobileTestIds } = useMemo(()=>GetMetricsHeaderMobileTID(testId), [
        testId
    ]);
    const isHeaderTappable = isCollapsed && !isEditMode;
    const showChevron = !isEditMode;
    const showCustomize = !isCollapsed && !isEditMode;
    const handleChevronClick = (event)=>{
        event.stopPropagation();
        onToggleCollapsed();
    };
    const handleHeaderKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggleCollapsed();
        }
    };
    return /*#__PURE__*/ _jsxs(Box, {
        className: cn(styles.root, {
            [styles.tappable]: isHeaderTappable
        }),
        testId: MetricsHeaderMobileTestIds.Root(),
        onClick: isHeaderTappable ? onToggleCollapsed : undefined,
        onKeyDown: isHeaderTappable ? handleHeaderKeyDown : undefined,
        role: isHeaderTappable ? 'button' : undefined,
        tabIndex: isHeaderTappable ? 0 : undefined,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                className: styles.title,
                testId: MetricsHeaderMobileTestIds.Title(),
                children: invoiceMetricsSectionTexts.title()
            }),
            isEditMode && /*#__PURE__*/ _jsx(TextButton, {
                className: styles.alignEnd,
                prefixIcon: /*#__PURE__*/ _jsx(Edit, {
                    size: 16
                }),
                underline: "none",
                weight: "normal",
                variant: "paragraph3",
                onClick: onDoneClick,
                testId: MetricsHeaderMobileTestIds.DoneButton(),
                bi: {
                    name: 'done_invoice_metrics_customize_mobile'
                },
                children: invoiceMetricsSectionTexts.doneButton()
            }),
            showCustomize && /*#__PURE__*/ _jsx(TextButton, {
                className: styles.alignEnd,
                prefixIcon: /*#__PURE__*/ _jsx(Edit, {
                    size: 16
                }),
                underline: "none",
                weight: "normal",
                variant: "paragraph3",
                disabled: !canCustomize,
                onClick: onCustomizeClick,
                testId: MetricsHeaderMobileTestIds.CustomizeButton(),
                bi: {
                    name: 'customize_invoice_metrics_mobile'
                },
                children: invoiceMetricsSectionTexts.customize()
            }),
            isEditMode && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        className: styles.divider,
                        margin: 0
                    }),
                    /*#__PURE__*/ _jsx(TextButton, {
                        ref: addWidgetButtonRef,
                        prefixIcon: /*#__PURE__*/ _jsx(PlusCircle, {
                            size: 16
                        }),
                        underline: "none",
                        weight: "normal",
                        variant: "paragraph3",
                        onClick: onAddWidgetClick,
                        testId: MetricsHeaderMobileTestIds.AddWidgetButton(),
                        bi: {
                            name: 'add_invoice_metric_widget_mobile'
                        },
                        children: invoiceMetricsSectionTexts.addWidgetButton()
                    })
                ]
            }),
            showChevron && /*#__PURE__*/ _jsx(IconButton, {
                className: cn({
                    [styles.alignEnd]: !showCustomize
                }),
                size: "xsmall",
                skin: "transparent",
                noPadding: true,
                "aria-label": isCollapsed ? invoiceMetricsSectionTexts.expandAriaLabel() : invoiceMetricsSectionTexts.collapseAriaLabel(),
                onClick: handleChevronClick,
                testId: MetricsHeaderMobileTestIds.CollapseToggle(),
                bi: {
                    name: 'toggle_invoice_metrics_collapsed',
                    data: {
                        collapsed: !isCollapsed
                    }
                },
                children: isCollapsed ? /*#__PURE__*/ _jsx(ChevronDown, {
                    size: 16
                }) : /*#__PURE__*/ _jsx(ChevronUp, {
                    size: 16
                })
            })
        ]
    });
};
